const PagePresentations = {
  PAGE: 'Page',
  SYSTEM: 'System',
};

module.exports = PagePresentations;
